<!-- Authord.by.KWShin.2024.02.27. -->
<template>
  <div :class="classes">
    <div v-if="type == 'range'" class="toolbox">
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveBackward(backward[1])" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-backward
            </v-icon>
          </v-btn>
        </template>
        <span>{{ previousTooltip(backward[1]) }}</span>
      </v-tooltip>
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveBackward(backward[0])" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-previous
            </v-icon>
          </v-btn>
        </template>
        <span>{{ previousTooltip(backward[0]) }}</span>
      </v-tooltip>
    </div>
    <div v-if="type == 'range'" class="d-flex">
      <v-text-field :value="bgnDatetime" class="mr-1" :style="{ width: '134px' }" solo dense hide-details readonly />
      <span class="pt-1">~</span>
    </div>
    <v-menu ref="datepicker" v-model="datepicker" transition="scale-transition" offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-text-field v-model="date" v-bind="attrs" v-on="on"
          append-icon="mdi-calendar" @click:append="on.click"
          class="mr-1" solo dense hide-details readonly
        ></v-text-field>
      </template>
      <!-- eslint-disable-next-line prettier/prettier -->
      <v-date-picker
        :value="date" color="primary" no-title scrollable
        :day-format="date => new Date(date).getDate()" @change="setDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="setToday">
          Today
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-menu v-model="timepicker" offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-text-field v-model="time" v-bind="attrs" v-on="on"
          append-icon="mdi-clock-time-four-outline" @click:append="on.click"
          class="mr-1" solo dense hide-details readonly
        ></v-text-field>
      </template>
      <!-- eslint-disable-next-line prettier/prettier -->
      <v-time-picker :value="time" @change="setTime"
        @input="updateTime"
        format="ampm" use-seconds scrollable
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="timepicker = false">
          {{ $t('common.select.done') }}
        </v-btn>
      </v-time-picker>
    </v-menu>
    <div class="toolbox">
      <v-tooltip v-if="type == 'default'" content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveBackward(backward[1])" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-backward
            </v-icon>
          </v-btn>
        </template>
        <span>{{ previousTooltip(backward[1]) }}</span>
      </v-tooltip>
      <v-tooltip v-if="type == 'default'" content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveBackward(backward[0])" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-previous
            </v-icon>
          </v-btn>
        </template>
        <span>{{ previousTooltip(backward[0]) }}</span>
      </v-tooltip>
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="increment > 0" @click="emitActiveIncrement(!activeIncrement)" :color="activeIncrement ? 'primary' : '#5A5A5A'" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(`components.tn.${activeIncrement ? 'stop' : 'play'}`) }}</span>
      </v-tooltip>
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveForward(forward[0])" :disabled="disabledForward" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-next
            </v-icon>
          </v-btn>
        </template>
        <span>{{ nextTooltip(forward[0]) }}</span>
      </v-tooltip>
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveForward(forward[1])" :disabled="disabledFurtherForward" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-forward
            </v-icon>
          </v-btn>
        </template>
        <span>{{ nextTooltip(forward[1]) }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line prettier/prettier
import { 
  addSeconds, subSeconds, startOfMinute, startOfHour, format,
  parseISO, getSeconds, setSeconds, getMinutes, setMinutes, isAfter
} from 'date-fns';
import { s2Hms } from '@/utils/formatter.js';

export default {
  props: {
    value: {
      type: [Number, Date],
      required: false,
      default: () => new Date(),
    },
    backward: {
      type: Array,
      required: true,
    },
    forward: {
      type: Array,
      required: true,
    },
    increment: {
      type: Number,
      required: false,
      default: -1,
    },
    activeIncrement: {
      type: Boolean,
      default: false,
    },
    // BEGIN::Added.by.KWShin.2024.09.09.
    // 'default'이면 기준시각 우측에 더이전/이전/이후/더이후 버튼을 보여주고
    // 'range'이면 기준시각 우측에 종료일시를 보여주고 더이전/이전은 좌측에 이후/더이후는 우측에 보여준다.
    type: {
      type: String,
      required: false,
      default: 'default',
    },
    // Added.by.KWShin.2024.09.09.
    // type='range'일 때 시간범위의 종료시각.
    beginDatetime: {
      type: [Number, Date],
    },
    // FINISH::Added.by.KWShin.2024.09.09.
  },
  data() {
    return {
      date: null,
      time: null,
      datepicker: false,
      timepicker: false,
      incrementSchedulerId: null,
      disabledForward: true,
      disabledFurtherForward: true,
      disabledForwardSchedulerId: null,
    };
  },
  computed: {
    classes() {
      return {
        'mr-auto': true,
        'd-flex ': true,
        'navigator-width': this.type == 'default' && this.increment > -1 ? false : true,
        'navigator-full-width': this.type == 'default' && this.increment > -1 ? true : false,
        'navigator-range-width': this.type == 'range' && this.increment > -1 ? false : true,
        'navigator-range-full-width': this.type == 'range' && this.increment > -1 ? true : false,
      };
    },
    // BEGIN::Added.by.KWShin.2024.09.09.
    bgnDatetime() {
      return format(this.beginDatetime, 'yyyy-MM-dd HH:mm:ss');
    },
    // FINISH::Added.by.KWShin.2024.09.09.
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.setDateTime(value, false);
      },
    },
    activeIncrement: {
      handler(value) {
        this.toggleAutoIncrement(value);
      },
    },
    // BEGIN::Added.by.KWShin.2024.02.28.
    // DatePicker/TimePicker가 열리면 실시간을 OFF 한다.
    datepicker: {
      handler(value) {
        if (value) this.emitActiveIncrement(false);
      },
    },
    timepicker: {
      handler(value) {
        if (value) this.emitActiveIncrement(false);
      },
    },
    // FINISH::Added.by.KWShin.2024.02.28.
  },
  methods: {
    // BEGIN::Added.by.KWShin.2023.02.29.
    previousTooltip(term) {
      return `${s2Hms(term)} ${this.$t('components.tn.previous')}`;
    },
    nextTooltip(term) {
      return `${s2Hms(term)} ${this.$t('components.tn.next')}`;
    },
    // FINISH::Added.by.KWShin.2023.02.29.
    canMoveForward(seconds) {
      if (this.activeIncrement) {
        return true;
      }
      return isAfter(new Date(), addSeconds(this.getDateTime(), seconds));
    },
    moveBackward(seconds) {
      this.emitActiveIncrement(false);
      this.setDateTime(subSeconds(this.getDateTime(), seconds));
    },
    moveForward(seconds) {
      this.emitActiveIncrement(false);
      this.setDateTime(addSeconds(this.getDateTime(), seconds));
    },
    getDateTime() {
      return parseISO(this.date + 'T' + this.time);
    },
    setDateTime(datetime, emit = true) {
      this.date = format(datetime, 'yyyy-MM-dd');
      this.time = format(datetime, 'HH:mm:ss');
      if (emit) {
        this.$emit('input', datetime);
        this.$emit('change', datetime);
      }
    },
    setToday() {
      const today = format(new Date(), 'yyyy-MM-dd');
      if (this.date !== today) {
        this.emitActiveIncrement(false);
        this.date = today;
        this.setDateTime(this.getDateTime());
      }
      // Added.by.KWShin.2024.02.28.DatePicker를 닫는다.
      this.datepicker = false;
    },
    setDate(date) {
      if (this.date !== date) {
        this.emitActiveIncrement(false);
        this.date = date;
        this.setDateTime(this.getDateTime());
      }
      // Added.by.KWShin.2024.02.28.DatePicker를 닫는다.
      this.datepicker = false;
    },
    /**
     * Commented.by.KWShin.2024.02.28.
     * TimePicker의 Event 'change'에 연결된 함수.
     * 최종적으로 초가 선택되면 선택된 시각이 넘어온다.
     */
    setTime(time) {
      if (this.time !== time) {
        this.emitActiveIncrement(false);
        this.time = time;
        this.setDateTime(this.getDateTime());
      }
      // Added.by.KWShin.2024.02.28.TimePicker를 닫는다.
      this.timepicker = false;
    },
    /**
     * Added.by.KWShin.2024.02.28.
     * TimePicker의 Event 'update'에 연결된 함수.
     * 시, 분, 초 중 어떤 것이라도 변경되면 파라미터에
     * 변경된 시각이 넘어온다.
     */
    updateTime(time) {
      if (this.time !== time) {
        this.time = time;
        this.setDateTime(this.getDateTime());
      }
    },
    startIncrementScheduler() {
      if (this.increment <= 60) {
        let seconds = getSeconds(this.value);
        seconds = seconds - (seconds % this.increment);
        this.setDateTime(setSeconds(this.value, seconds), false);
      } else if (this.increment >= 60 && this.increment <= 3600) {
        let minutes = getMinutes(this.value);
        minutes = minutes - (minutes % (this.increment / 60));
        this.setDateTime(startOfMinute(setMinutes(this.value, minutes)), false);
      } else {
        this.setDateTime(startOfHour(this.value), false);
      }

      // Modified.by.KWShin.2024.09.09.
      // increment에 음수가 들어오면 이 루틴에 문제가 있네...
      // 시간 필드의 시간이 거꾸로 급속도로 줄어드네...ㅋㅋ 뭐 그러면서 다른데는 영향이 없어 보이네
      // 음수가 넘어오면 1로 대체하는 걸로 수정.
      if (!this.incrementSchedulerId) {
        this.incrementSchedulerId = setInterval(() => {
          this.setDateTime(addSeconds(this.getDateTime(), this.increment > 0 ? this.increment : 1));
        }, (this.increment > 0 ? this.increment : 1) * 1000);
      }
      this.stopDisabledForwardScheduler();
    },
    stopIncrementScheduler() {
      if (this.incrementSchedulerId) {
        clearInterval(this.incrementSchedulerId);
        this.incrementSchedulerId = null;
      }
      this.startDisabledForwardScheduler();
    },
    startDisabledForwardScheduler() {
      if (!this.disabledForwardSchedulerId) {
        this.disabledForwardSchedulerId = setInterval(() => {
          this.disabledForward = !this.canMoveForward(this.forward[0]);
          this.disabledFurtherForward = !this.canMoveForward(this.forward[1]);
        }, 300);
      }
    },
    stopDisabledForwardScheduler() {
      if (this.disabledForwardSchedulerId) {
        clearInterval(this.disabledForwardSchedulerId);
        this.disabledForwardSchedulerId = null;
      }
      this.disabledForward = true;
      this.disabledFurtherForward = true;
    },
    toggleAutoIncrement(obj) {
      if (this.increment > 0) {
        this.activeIncrement = obj instanceof Event ? !this.activeIncrement : obj;
        if (this.activeIncrement) {
          this.startIncrementScheduler();
        } else {
          this.stopIncrementScheduler();
        }
      }
    },
    emitActiveIncrement(active) {
      this.$emit('update:activeIncrement', active);
    },
  },
  created() {
    if (this.activeIncrement) {
      this.startIncrementScheduler();
    } else {
      this.startDisabledForwardScheduler();
    }
  },
  beforeDestroy() {
    clearInterval(this.incrementSchedulerId);
    clearInterval(this.disabledForwardSchedulerId);
  },
};
</script>

<style lang="scss" scoped>
.navigator-width {
  max-width: 376px;
}
.navigator-full-width {
  max-width: 408px;
}
.navigator-range-width {
  max-width: 526px;
}
.navigator-range-full-width {
  max-width: 558px;
}
.time-font {
  font-size: 11px !important;
}
.tooltip {
  font-size: 11px;
  padding: 3px 5px 3px 5px;
  opacity: 1 !important;
}
</style>
